import { lazy } from "react";

const Layout = lazy(() => {
  return import.meta.env.VITE_MODE === "admin"
    ? import("./Layout.admin")
    : import("./Layout");
});

export default Layout;
